import $ from 'jquery'
import Handbook from './handbooks'
import SentryWrapper from '../../../ui/js/utils/SentryWrapper'

// On doc.ready.
$(function () {
    new SentryWrapper()
    Handbook.init()
})


